import { AddBoxOutlined } from "@mui/icons-material";
import Button from '@mui/material/Button';
import React, { useEffect, useState } from 'react';
import { Accordion, Card } from "react-bootstrap";
import Scroll from 'react-scroll';
import SelectImgComp from '../ImagesSetter/SelectImgComp';
import EraseCheck from '../PopUps/EraseCheck';
import RichTextComp from "../TextEditor/RichText";
import InputTextSimple from "./InputTextSimple";
import MyTextArea from "../TextEditor/MyTextArea";
var scroller = Scroll.scroller;

const ImgAndTxtAndLnkCARD = (props) => {
    const [contentList, setContentList] = useState(props.TheList);
    const [displyList, setDisplyList] = useState();
    const [thePopUp, setThePopUp] = useState("");

    useEffect(() => {
        setContentList(props.TheList);
    }, [props.TheList]);

    useEffect(() => {
        setTheDisplay();
    }, [contentList]);

    const setTheDisplay = () => {
        let counter = 0;
        let bk = contentList.map((item, index) => {
            counter++;
            return (
                <tr key={index}>
                    <td className="l2row">
                        {index !== 0 && contentList.length > 1 ? (
                            <div className={"iconsOnLeft pointing"} onClick={() => setUp(index)} title={"הקפץ למעלה"}>
                                <i className="far fa-caret-square-up theIconsColor" />
                            </div>
                        ) : ""}
                        {index < contentList.length - 1 ? (
                            <div className={"iconsOnLeft pointing"} onClick={() => setDown(index)} title={"הקפץ למטה"}>
                                <i className="far fa-caret-square-down theIconsColor" />
                            </div>
                        ) : ""}
                    </td>
                    <td className="frow">
                        <SelectImgComp
                            imgCss={"betweenImgDisp pointing"}
                            firstImgToDisp={item.img ? item.img : ""}
                            theFunction={(fUrl) => setTheImg(index, fUrl)}
                        />

                    </td>
                    <td className="frow">
                        <SelectImgComp
                            imgCss={"betweenImgDisp pointing"}
                            firstImgToDisp={item.imgMobi ? item.imgMobi : ""}
                            theFunction={(fUrl) => setTheImgMobi(index, fUrl)}
                        />
                    </td>

                    <td className="mrow slideRichTextComp">
                        <div className={"input-group"}>
                            <InputTextSimple
                                lbl="כותרת עליונה"
                                lblCss="bold"
                                Typ="text"
                                Css="regularInput"
                                Val={item.headTxt}
                                placeholder="שם הלקוח"
                                settingFunc={(val) => setTheheadTxt(index, val)}
                            />
                        </div>
                        <div className={"input-group"}>
                            <MyTextArea
                                lbl="טקסט"
                                lblCss="bold"
                                firstText={item.txt}
                                cssStyle={'regularInput'}
                                saveEditorTxt={(content) => { setTheTxt(index, content) }}
                            />
                        </div>
                        <div className={"col-md-12 mb-2"}>
                            <div className={"input-group"}>
                                <InputTextSimple
                                    lbl="קישור כפתור"
                                    lblCss="bold"
                                    Typ="text"
                                    Css="regularInput dirLeft"
                                    Val={item.lnk}
                                    placeholder="http://www...."
                                    settingFunc={(val) => setTheLink(index, val)}
                                />
                            </div>
                            <div className={"input-group"}>
                                <InputTextSimple
                                    lbl="טקסט על הכפתור"
                                    lblCss="bold"
                                    Typ="text"
                                    Css="regularInput"
                                    Val={item.btnTxtLink}
                                    placeholder="לחץ כאן..."
                                    settingFunc={(val) => setTheBtnTxtLink(index, val)}
                                />
                            </div>
                        </div>
                    </td>
                    <td className="lrow">
                        <div className={"iconsOnLeft pointing"} onClick={() => removeItm(index)}>
                            <i className="far fa-trash-alt theIconsColor" />
                        </div>
                    </td>
                </tr>
            );
        });
        setDisplyList(bk);
    };

    const array_move = (arr, old_index, new_index) => {
        if (new_index >= arr.length) {
            var k = new_index - arr.length + 1;
            while (k--) {
                arr.push(undefined);
            }
        }
        arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
        return arr;
    };

    const setUp = (index) => {
        setContentList((prevList) => {
            let temp = array_move([...prevList], index, index - 1);
            props.theFunction(temp);
            return temp;
        });
    };

    const setDown = (index) => {
        setContentList((prevList) => {
            let temp = array_move([...prevList], index, index + 1);
            props.theFunction(temp);
            return temp;
        });
    };

    const removeItm = (index) => {
        setThePopUp(<EraseCheck title={'האם בטוח למחוק את התמונה והטקסט?'} sucecssFunc={() => removeItmConfirmd(index)} />);
    };

    const removeItmConfirmd = async (index) => {
        setContentList((prevList) => {
            let temp = [...prevList];
            temp.splice(index, 1);
            props.theFunction(temp);
            return temp;
        });
    };

    const setTheheadTxt = (index, val) => {
        setContentList((prevList) => {
            let temp = [...prevList];
            temp[index].headTxt = val;
            props.theFunction(temp);
            return temp;
        });
    };

    const setTheTxt = (index, text) => {
        setContentList((prevList) => {
            let temp = [...prevList];
            temp[index].txt = text;
            props.theFunction(temp);
            return temp;
        });
    };

    const setTheLink = (index, val) => {
        setContentList((prevList) => {
            let temp = [...prevList];
            temp[index].lnk = val;
            props.theFunction(temp);
            return temp;
        });
    };

    const setTheBtnTxtLink = (index, val) => {
        setContentList((prevList) => {
            let temp = [...prevList];
            temp[index].btnTxtLink = val;
            props.theFunction(temp);
            return temp;
        });
    };

    const setTheImg = (index, theUrl) => {
        setContentList((prevList) => {
            let temp = [...prevList];
            temp[index].img = theUrl;
            props.theFunction(temp);
            return temp;
        });
    };


    const setTheImgMobi = (index, theUrl) => {
        setContentList((prevList) => {
            let temp = [...prevList];
            temp[index].imgMobi = theUrl;
            props.theFunction(temp);
            return temp;
        });
    };


    const createNewItm = () => {
        setContentList((prevList) => {
            let temp = [...prevList];
            temp.push({ img: "", imgMobi: "", txt: "" });
            props.theFunction(temp);
            return temp;
        });
    };

    const scrolltoMe = (elem) => {
        scroller.scrollTo(elem, { smooth: true, offset: -100, duration: 2000 });
    };

    return (
        <>
            <div>
                <div className={"smallBtnsLine"}>
                    <Button className={"btnSPc"} variant="contained" onClick={() => createNewItm()} startIcon={<AddBoxOutlined style={{ color: 'white' }} />}>
                        הוסף
                    </Button>
                </div>
                <div className="table-responsive">
                    <table className="table table-hover thead-primary">
                        <thead>
                            <tr>
                                <th scope="col" className={"centerText"}>{props.tblHeads[0] ? props.tblHeads[0] : ""}</th>
                                <th scope="col" className={"centerText"}>{props.tblHeads[1] ? props.tblHeads[1] : ""}</th>
                                <th scope="col" className={"centerText"}>{props.tblHeads[2] ? props.tblHeads[2] : ""}</th>
                                <th scope="col" className={"centerText"}>{props.tblHeads[2] ? props.tblHeads[3] : ""}</th>
                                <th scope="col" className={"centerText l2row"}>{props.tblHeads[4] ? props.tblHeads[4] : ""}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {displyList}
                        </tbody>
                    </table>
                </div>
            </div>
            {thePopUp}
        </>
    );
};

export default ImgAndTxtAndLnkCARD;
